export const formatDateInIST = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(date);
    const values = Object.fromEntries(
        parts.map(({ type, value: partValue }) => [type, partValue])
    );
    return `${values.year}-${values.month}-${values.day}`;
};

export const formatDateTimeInIST = (value = new Date()) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).format(date);
};

export const formatPeople = (people) =>
    Array.isArray(people) && people.length
        ? people
              .filter(Boolean)
              .map((person) =>
                  [person.name, person.role ? `(${person.role})` : ""]
                      .filter(Boolean)
                      .join(" ")
              )
              .join("; ")
        : "";

export const sanitizeSheetName = (name) =>
    String(name || "Sheet")
        .replace(/[/\\?*[\]:]/g, " ")
        .trim()
        .slice(0, 31) || "Sheet";

export const buildUniqueSheetNames = (names, reservedNames = []) => {
    const used = new Set(
        reservedNames.map((name) => String(name).toLowerCase())
    );

    return names.reduce((result, name) => {
        const base = sanitizeSheetName(name);
        let candidate = base;
        let suffixNumber = 2;

        while (used.has(candidate.toLowerCase())) {
            const suffix = ` (${suffixNumber})`;
            candidate = `${base.slice(0, 31 - suffix.length).trim()}${suffix}`;
            suffixNumber += 1;
        }

        used.add(candidate.toLowerCase());
        result[name] = candidate;
        return result;
    }, {});
};
